
import { FormControlLabel, Grid, Switch, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { checkNumber } from "../utilities/FormValidation";
import OAuthService from "src/app/auth/services/oAuthService";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";

const BankForm = forwardRef((props, ref) => {
    const [validError, setValidError] = useState();
    const [error, setError] = useState();
    const [successMsg, setSuccessMsg] = useState();
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [editData, setEditdata] = useState();
    const [bankData, setBankData] = useState({
        bank: '',
        bankIdentifierCode: "",
        bankAddress: '',
        issuingBankName: '',
    })
    const bankUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.bankInfoes}`;

    const getEditBank = async () => {
        let id = props.select[0]._links?.self?.href.split('/').pop();
        try {
            const refData = await OAuthService.getList(bankUrl + `/${id}`)
            if (refData?.data) {
                setBankData({
                    ...bankData,
                    bank: refData.data.bank,
                    bankIdentifierCode: refData.data.bankIdentifierCode,
                    bankAddress: refData.data.bankAddress,
                    issuingBankName: refData.data.issuingBankName,
                })
                setEditdata({
                    ...bankData,
                    bank: refData.data.bank,
                    bankIdentifierCode: refData.data.bankIdentifierCode,
                    bankAddress: refData.data.bankAddress,
                    issuingBankName: refData.data.issuingBankName,
                })
            }
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message);
        }

    }
    useEffect(() => {
        let id = props.select[0]?._links?.self?.href.split('/').pop();
        if (id) {
            getEditBank()
        }
    }, [])

    const handleBankDataChange = (e) => {
        console.log(e.target.value,e.target.name);
        setBankData({ ...bankData, [e.target.name]: e.target.value })
    }

    useEffect(() => {
        if (bankData?.bank && bankData?.bankAddress && bankData?.bankIdentifierCode && bankData?.issuingBankName && !validError) {
            if (bankData?.bank !== editData?.bank || bankData?.bankAddress !== editData?.bankAddress || bankData?.bankIdentifierCode !== editData?.bankIdentifierCode || bankData?.issuingBankName !== editData?.issuingBankName) {
                setSaveDisabled(false);
            }
            else {
                setSaveDisabled(true)
            }
        } else {
            setSaveDisabled(true)
        }
    }, [bankData])

    useEffect(() => {
        props.checkSaveDisabled(saveDisabled)
    }, [saveDisabled])

    const handleSubmit = async () => {
        let model = {
            ...bankData
        }

        let id = props.select[0]?._links?.self?.href.split('/').pop();
        try {
            if (id) {
                await OAuthService.updateData(bankUrl, id, model);
                setSuccessMsg("Bank Updated Successfully")
                return 'Bank Updated successfully.'
            }
            else {
                await OAuthService.addData(bankUrl, model);
                setSuccessMsg('Bank added successfully.')
                return 'Bank added successfully.'
            }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message);
        }
    }

    useImperativeHandle(ref, () => ({
        handleSubmit: handleSubmit
    }))
    useEffect(() => {
        props.successMsg(successMsg)
    }, [successMsg]);

    return (
        <>
            <Grid container spacing={2} className="mt-2">
                <Grid item xs={5}>
                    <label className="min-w-fit">Bank</label>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        name='bank'
                        value={bankData.bank}
                        size="small"
                        onChange={(e) => { handleBankDataChange(e);}}
                        helperText={validError}
                    />
                </Grid>

            </Grid>
            <Grid container spacing={2} className="mt-2">
                <Grid item xs={5}>
                    <label className="min-w-fit">Bank Identifier Code</label>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        name='bankIdentifierCode'
                        value={bankData.bankIdentifierCode}
                        size="small"
                        onChange={handleBankDataChange}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} className="mt-2">
                <Grid item xs={5}>
                    <label className="min-w-fit">Bank Address</label>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        name='bankAddress'
                        value={bankData.bankAddress}
                        size="small"
                        onChange={handleBankDataChange}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} className="mt-2">
                <Grid item xs={5}>
                    <label className="min-w-fit">Issuing Bank Name</label>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        name='issuingBankName'
                        value={bankData.issuingBankName}
                        size="small"
                        onChange={handleBankDataChange}
                    />
                </Grid>
            </Grid>
        </>

    )
})
export default BankForm